import React, { useContext } from 'react';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { useTheme } from '@mui/material';

export default function IconEyeClosed({
  extColor,
  isAutoscallable = true,
  sizeKey = '16x16',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.custom.customDark;

  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M5.3325 2.99341C5.23371 2.88204 5.11379 2.79139 4.9797 2.72671C4.84561 2.66204 4.70002 2.62461 4.55137 2.61661C4.40271 2.60862 4.25394 2.6302 4.11369 2.68013C3.97344 2.73005 3.84449 2.80731 3.73431 2.90743C3.62414 3.00755 3.53493 3.12855 3.47187 3.2634C3.4088 3.39826 3.37313 3.54429 3.36691 3.69303C3.3607 3.84177 3.38407 3.99027 3.43566 4.12991C3.48726 4.26956 3.56606 4.39757 3.6675 4.50653L5.1675 6.16122C1.93781 8.31185 0.536252 11.3981 0.468752 11.5434C0.405239 11.6874 0.372437 11.8431 0.372437 12.0004C0.372437 12.1578 0.405239 12.3135 0.468752 12.4575C0.503439 12.5343 1.32469 14.3568 3.13969 16.1709C5.56594 18.5943 8.625 19.875 12 19.875C13.6403 19.8841 15.2659 19.5653 16.7813 18.9375L18.6647 21.0093C18.8664 21.226 19.1454 21.3545 19.4412 21.3668C19.7369 21.3792 20.0257 21.2745 20.2447 21.0754C20.4638 20.8763 20.5956 20.5988 20.6115 20.3032C20.6274 20.0076 20.5261 19.7177 20.3297 19.4962L5.3325 2.99341ZM12 17.625C9.22594 17.625 6.79969 16.619 4.78969 14.6362C3.99905 13.8534 3.31874 12.9665 2.7675 12C3.26156 11.1272 4.52906 9.19685 6.705 7.84778L15.1509 17.1393C14.1324 17.4646 13.0692 17.6284 12 17.625ZM23.5313 12.4575C23.4975 12.5334 22.6875 14.3325 20.9063 16.1287C20.8043 16.2419 20.6803 16.3333 20.542 16.3971C20.4036 16.461 20.2537 16.4961 20.1014 16.5003C19.949 16.5045 19.7974 16.4777 19.6558 16.4215C19.5141 16.3654 19.3853 16.281 19.2773 16.1736C19.1692 16.0661 19.0841 15.9379 19.0271 15.7965C18.9701 15.6552 18.9424 15.5038 18.9457 15.3514C18.949 15.199 18.9832 15.049 19.0462 14.9102C19.1093 14.7715 19.1999 14.647 19.3125 14.5443C20.0607 13.7836 20.7062 12.9282 21.2325 12C20.6816 11.0333 20.0012 10.1463 19.2103 9.36372C17.1994 7.38091 14.7741 6.37497 12 6.37497C11.6859 6.37497 11.3719 6.3881 11.0625 6.41435C10.9134 6.43032 10.7626 6.41633 10.619 6.37319C10.4754 6.33006 10.3419 6.25866 10.2263 6.16318C10.1107 6.0677 10.0153 5.95007 9.94582 5.81721C9.87632 5.68435 9.83408 5.53894 9.82158 5.38952C9.80908 5.24011 9.82658 5.0897 9.87304 4.94714C9.9195 4.80458 9.994 4.67274 10.0921 4.55938C10.1903 4.44603 10.3101 4.35343 10.4445 4.28704C10.579 4.22065 10.7253 4.1818 10.875 4.17278C11.2434 4.14091 11.625 4.12497 12 4.12497C15.375 4.12497 18.4341 5.40653 20.8584 7.82997C22.6725 9.64403 23.4938 11.4675 23.5284 11.5434C23.5924 11.6872 23.6257 11.8428 23.6262 12.0001C23.6266 12.1575 23.5943 12.3133 23.5313 12.4575Z"
      />
    </svg>
  );
}
